import { Components } from "@mui/material/styles";

export const MuiFormControlLabel: Components["MuiFormControlLabel"] = {
    styleOverrides: {
        root: {
            "&.Mui-disabled": {
                cursor: "not-allowed",
            },
        },
    },
};
